<div>
  @for (displayItem of displayList; track displayItem.colDef.headerName) {
    <div>
      @if (isGroup(displayItem.colDef)) {
        <div class="flex items-center">
          <em-icon
            class="cursor-pointer"
            [name]="displayItem.expand ? 'expand_less' : 'expand_more'"
            (click)="expandCollapseGroup(displayItem)"
          ></em-icon>
          <div>
            <em-checkbox
              [(ngModel)]="displayItem.checked"
              [indeterminate]="someChildrenVisible(displayItem)"
              (valueChange)="groupValueChange(displayItem, $event)"
              >{{ displayItem.colDef.headerName }}
            </em-checkbox>
          </div>
        </div>
        @if (displayItem.expand) {
          <div class="ml-16">
            @for (
              childDisplayItem of displayItem.children;
              track childDisplayItem.colDef.headerName
            ) {
              <div>
                @if (isColumn(childDisplayItem.colDef)) {
                  <em-checkbox
                    [(ngModel)]="childDisplayItem.checked"
                    (valueChange)="
                      colValueChange(childDisplayItem, displayItem, $event)
                    "
                    >{{ childDisplayItem.colDef.headerName }}
                  </em-checkbox>
                }
              </div>
            }
          </div>
        }
      }
      @if (isColumn(displayItem.colDef)) {
        <em-checkbox
          class="ml-9"
          [(ngModel)]="displayItem.checked"
          (valueChange)="colValueChange(displayItem, undefined, $event)"
          >{{ displayItem.colDef.field }}
        </em-checkbox>
      }
    </div>
  }
</div>
